import { set, omit } from 'lodash/fp';
import createReducer from '../../../../helpers/createReducer';
import { createFetchManyHandler } from '../../../../helpers/reducerRoutineCrudHandler';
import {
  paginationState,
  resetPaginationState
} from '../../../../helpers/pagination';
import {
  fetchReservationArchived,
  unlinkReservation
} from '../../sagas/routines';
import {
  clearReservationArchived,
  reservationArchivedOnChangePage,
  reservationArchivedOnChangeOrder,
  reservationArchivedRemoveItem
} from '../../actions/archived';

const initialState = {
  all: {},
  fetching: false,
  fetched: false,
  saving: false,
  saved: false,
  fetchingError: null,
  pagination: paginationState(),
  order: 'requestTime:desc'
};

const unlinkReservationHandler = routine => ({
  [routine.TRIGGER]: state => ({ ...state, saving: true, saved: false }),
  [routine.SUCCESS]: (state, { payload: { response } }) =>
    set(`all.${response.id}`, response, state),
  [routine.FULFILL]: state => ({
    ...state,
    saving: false,
    saved: true
  })
});

const clearReservationArchivedHandler = action => ({
  [action.toString()]: state => ({
    ...state,
    all: {},
    pagination: resetPaginationState(state.pagination)
  })
});

const reservationArchivedOnChangePageHandler = action => ({
  [action.toString()]: (state, { payload: page }) =>
    set('pagination.currentPage', page, state)
});

const reservationArchivedOnChangeOrderHandler = action => ({
  [action.toString()]: (state, { payload: order }) => set('order', order, state)
});

const reservationArchivedRemoveItemHandler = action => ({
  [action.toString()]: (state, { payload: id }) => ({
    ...state,
    all: omit(id, state.all)
  })
});

export default createReducer(initialState, {
  ...createFetchManyHandler(fetchReservationArchived),
  ...unlinkReservationHandler(unlinkReservation),
  ...clearReservationArchivedHandler(clearReservationArchived),
  ...reservationArchivedOnChangePageHandler(reservationArchivedOnChangePage),
  ...reservationArchivedOnChangeOrderHandler(reservationArchivedOnChangeOrder),
  ...reservationArchivedRemoveItemHandler(reservationArchivedRemoveItem)
});
